var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIabStandard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.6917 22.3984C32.4165 22.3984 31.3828 23.4278 31.3828 24.6978C31.3828 25.9683 32.4165 26.998 33.6917 26.998C34.9666 26.998 36.0003 25.9683 36.0003 24.6978C36.0003 23.4278 34.9666 22.3984 33.6917 22.3984Z",
    fill: "#EE3425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.30855 9.3125C1.03369 9.3125 0 10.3423 0 11.6123C0 12.8823 1.03369 13.9117 2.30855 13.9117C3.58341 13.9117 4.61749 12.8823 4.61749 11.6123C4.61749 10.3423 3.58341 9.3125 2.30855 9.3125Z",
    fill: "#EE3425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.537109 15.5078H4.07969V26.9181H0.537109V15.5078Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.5019 17.1687C27.5326 16.14 26.1764 15.4983 24.6951 15.4991C23.5852 15.4983 22.5457 15.8591 21.6861 16.4728V9H18.1436V26.9147H21.6861V25.9249C22.5445 26.5386 23.5828 26.8994 24.6924 26.8994H24.6951C26.1764 26.8998 27.5326 26.2581 28.5019 25.2295C29.4732 24.2035 30.0789 22.7677 30.0781 21.199C30.0789 19.6308 29.4732 18.1942 28.5019 17.1687ZM23.9912 23.485C22.7163 23.485 21.6835 22.4549 21.6835 21.1853C21.6835 19.9148 22.7163 18.8854 23.9912 18.8854C25.2665 18.8854 26.3001 19.9148 26.3001 21.1853C26.3001 22.4549 25.2665 23.485 23.9912 23.485Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.4465 15.5058V16.4833C12.5857 15.8639 11.5428 15.4996 10.429 15.5C8.94958 15.4996 7.59573 16.1414 6.62793 17.17C5.65743 18.1955 5.05333 19.6318 5.05371 21.2003C5.05333 22.769 5.65743 24.2048 6.62793 25.2308C7.59573 26.2598 8.94958 26.9015 10.429 26.9007H10.4318C11.5448 26.9007 12.5869 26.5365 13.4465 25.9174V26.9165H16.9891V15.5058H13.4465ZM11.1321 23.4863C9.85728 23.4863 8.82399 22.4566 8.82399 21.1866C8.82399 19.9161 9.85728 18.8867 11.1321 18.8867C12.4074 18.8867 13.4411 19.9161 13.4411 21.1866C13.4411 22.4566 12.4074 23.4863 11.1321 23.4863Z",
    fill: "#020202"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIabStandard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iab-standard.31a631518807da04afd098b14d2cf47f.svg";